// src/components/Strength/StrengthMetricsProcessor.js
import { useEffect } from 'react';
import axios from 'axios';
import { calculateHrTSSStrength } from '../../utils/hrTssStrengthUtils';
import API_BASE_URL from '../../config/api';

const StrengthMetricsProcessor = ({ fileId, onSummaryData }) => {
  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await axios.get(`${API_BASE_URL}/api/fit/parsed-data/${fileId}`);
        const data = res.data;
        const baseSession = data?.session || {};
        const extendedSession = data?.sessions?.[0] || {};
        const session = { ...baseSession, ...extendedSession };
        const records = data?.records || [];
        const laps = data?.laps || [];
        const sportType = data.sportType || '';
        const zonesTarget = data?.zones_target || {};

        const totalReps = session.total_repetitions !== undefined ? session.total_repetitions : (session.total_cycles || 0);
        const totalWork = session.total_work;
        const validTotalReps = typeof totalReps === 'number' && totalReps > 0;
        const validTotalWork = typeof totalWork === 'number' && totalWork > 0;

        const ftpFromZones = zonesTarget.functional_threshold_power;
        const ftpEstimado = ftpFromZones !== undefined && ftpFromZones !== null ? ftpFromZones : 'Sin datos';

        const avgHR = session.avg_heart_rate || 0;
        const thresholdHeartRate = zonesTarget.threshold_heart_rate || 145;
        const movementTime = session.total_timer_time || session.total_elapsed_time || 0;
        const tssCalculado = calculateHrTSSStrength(avgHR, thresholdHeartRate, movementTime);

		const completed = {
		  duracion: session.total_elapsed_time || 0,
		  calorias: session.total_calories || 0,
		  tss: isFinite(tssCalculado) ? tssCalculado : '-',
		  te: session.total_training_effect || '-',
		  tea: session.total_anaerobic_effect || '-',
		  repeticiones: validTotalReps ? totalReps : '-',
		  series: session.total_sets || '-',
		  peso_promedio: session.avg_weight || '-',
		};

        const metrics = {
          ritmo_cardiaco: {
            min: session.min_heart_rate || '-',
            avg: session.avg_heart_rate || '-',
            max: session.max_heart_rate || '-',
          },
          trabajo_total: validTotalWork ? totalWork : '-',
          intensity_factor: session.intensity_factor || '-',
          np: session.normalized_power || '-',
          ftp: ftpEstimado,
        };

        if (typeof onSummaryData === 'function') {
          onSummaryData({ session, completed, laps, records, metrics, sportType, sport: session.sport || '', subSport: session.sub_sport || '' });
        }
      } catch (error) {
        console.error('Error al obtener datos de fuerza:', error);
      }
    };

    if (fileId) {
      fetchData();
    }
  }, [fileId, onSummaryData]);

  return null;
};

export default StrengthMetricsProcessor;
